/**
 * Nucery PDP gallery — instant preview + background hi-res load.
 */
(function () {
  'use strict';

  if (window.__nuceryPdpGallery) {
    return;
  }
  window.__nuceryPdpGallery = true;

  var modal;
  var imgEl;
  var loaderEl;
  var viewportEl;
  var slides = [];
  var index = 0;
  var preloadCache = Object.create(null);
  var loadToken = 0;
  var zoomScale = 2;
  var zoomed = false;
  var panX = 0;
  var panY = 0;
  var dragActive = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var panStartX = 0;
  var panStartY = 0;
  var zoomBound = false;

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function preloadUrl(url) {
    if (!url) {
      return Promise.resolve();
    }
    if (preloadCache[url]) {
      return preloadCache[url];
    }
    preloadCache[url] = new Promise(function (resolve) {
      var img = new Image();
      img.decoding = 'async';
      var done = function () {
        resolve(img);
      };
      img.onload = done;
      img.onerror = done;
      img.src = url;
      if (img.complete) {
        done();
      }
    });
    return preloadCache[url];
  }

  function readZoomScale() {
    if (!modal) {
      return 2;
    }
    var raw = parseFloat(modal.getAttribute('data-zoom-scale'), 10);
    if (!raw || isNaN(raw)) {
      return 2;
    }
    return raw > 10 ? raw / 100 : raw;
  }

  function applyTransform() {
    if (!imgEl) {
      return;
    }
    if (zoomed) {
      imgEl.style.transform =
        'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomScale + ')';
    } else {
      imgEl.style.transform = '';
    }
  }

  function clampPan() {
    if (!viewportEl || !imgEl || !zoomed) {
      return;
    }
    var vRect = viewportEl.getBoundingClientRect();
    var baseW = imgEl.offsetWidth;
    var baseH = imgEl.offsetHeight;
    var scaledW = baseW * zoomScale;
    var scaledH = baseH * zoomScale;
    var maxX = Math.max(0, (scaledW - vRect.width) / 2);
    var maxY = Math.max(0, (scaledH - vRect.height) / 2);
    panX = Math.max(-maxX, Math.min(maxX, panX));
    panY = Math.max(-maxY, Math.min(maxY, panY));
  }

  function resetZoom() {
    zoomed = false;
    panX = 0;
    panY = 0;
    dragActive = false;
    if (modal) {
      modal.classList.remove('npl--zoomed');
    }
    if (viewportEl) {
      viewportEl.classList.remove('npl--dragging');
    }
    applyTransform();
  }

  function toggleZoom(evt) {
    if (!viewportEl || !imgEl || (modal && modal.classList.contains('npl--loading'))) {
      return;
    }
    if (!zoomed) {
      zoomScale = readZoomScale();
      zoomed = true;
      modal.classList.add('npl--zoomed');
      var rect = viewportEl.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var ox = evt.clientX - cx;
      var oy = evt.clientY - cy;
      panX = -ox * (zoomScale - 1);
      panY = -oy * (zoomScale - 1);
      clampPan();
    } else {
      resetZoom();
      return;
    }
    applyTransform();
  }

  function bindZoom() {
    if (!viewportEl || zoomBound) {
      return;
    }
    zoomBound = true;

    viewportEl.addEventListener('dblclick', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      toggleZoom(evt);
    });

    viewportEl.addEventListener('mousedown', function (evt) {
      if (!zoomed || evt.button !== 0) {
        return;
      }
      evt.preventDefault();
      dragActive = true;
      dragStartX = evt.clientX;
      dragStartY = evt.clientY;
      panStartX = panX;
      panStartY = panY;
      viewportEl.classList.add('npl--dragging');
    });

    viewportEl.addEventListener(
      'touchstart',
      function (evt) {
        if (!zoomed || evt.touches.length !== 1) {
          return;
        }
        dragActive = true;
        dragStartX = evt.touches[0].clientX;
        dragStartY = evt.touches[0].clientY;
        panStartX = panX;
        panStartY = panY;
        viewportEl.classList.add('npl--dragging');
      },
      { passive: true }
    );

    viewportEl.addEventListener(
      'touchmove',
      function (evt) {
        if (!dragActive || !zoomed || evt.touches.length !== 1) {
          return;
        }
        panX = panStartX + (evt.touches[0].clientX - dragStartX);
        panY = panStartY + (evt.touches[0].clientY - dragStartY);
        clampPan();
        applyTransform();
      },
      { passive: true }
    );

    viewportEl.addEventListener('touchend', function () {
      dragActive = false;
      viewportEl.classList.remove('npl--dragging');
    });

    document.addEventListener('mousemove', function (evt) {
      if (!dragActive) {
        return;
      }
      panX = panStartX + (evt.clientX - dragStartX);
      panY = panStartY + (evt.clientY - dragStartY);
      clampPan();
      applyTransform();
    });

    document.addEventListener('mouseup', function () {
      if (!dragActive) {
        return;
      }
      dragActive = false;
      if (viewportEl) {
        viewportEl.classList.remove('npl--dragging');
      }
    });
  }

  function ensureModal() {
    if (modal) {
      return modal;
    }
    modal = document.getElementById('nucery-pdp-lightbox');
    if (!modal) {
      return null;
    }
    imgEl = modal.querySelector('.npl__img');
    loaderEl = modal.querySelector('.npl__loader');
    viewportEl = modal.querySelector('[data-npl-viewport]');
    bindZoom();

    modal.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-npl-close], .npl__backdrop')) {
        close();
      }
    });

    var prev = modal.querySelector('[data-npl-prev]');
    var next = modal.querySelector('[data-npl-next]');
    if (prev) {
      prev.addEventListener('click', function (e) {
        e.stopPropagation();
        go(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.stopPropagation();
        go(1);
      });
    }

    document.addEventListener('keydown', function (evt) {
      if (!modal || modal.hidden) {
        return;
      }
      if (evt.key === 'Escape') {
        close();
      } else if (evt.key === 'ArrowLeft') {
        go(-1);
      } else if (evt.key === 'ArrowRight') {
        go(1);
      }
    });

    return modal;
  }

  function slideNodes(root) {
    var grid = root.querySelector('.product__photos-grid');
    if (grid) {
      var rect = grid.getBoundingClientRect();
      if (rect.width > 2 && rect.height > 2) {
        return $all('[data-nucery-zoom-src]', grid);
      }
    }
    var slideshow = root.querySelector('.product-slideshow');
    if (slideshow) {
      return $all('[data-nucery-zoom-src]', slideshow);
    }
    return $all('[data-nucery-zoom-src]', root);
  }

  function collectSlides(root) {
    var list = [];
    var seen = {};

    slideNodes(root).forEach(function (node) {
      var src = node.getAttribute('data-nucery-zoom-src');
      if (!src || seen[src]) {
        return;
      }
      seen[src] = true;

      var idx = parseInt(node.getAttribute('data-nucery-zoom-index'), 10);
      if (isNaN(idx)) {
        idx = list.length;
      }

      var thumb = node.querySelector('img');
      var preview = '';
      if (thumb) {
        preview = thumb.currentSrc || thumb.src || '';
      }

      list.push({
        src: src,
        preview: preview,
        alt: thumb ? thumb.getAttribute('alt') || '' : '',
        order: idx,
      });
    });

    list.sort(function (a, b) {
      return a.order - b.order;
    });

    return list;
  }

  function warmCache(root) {
    collectSlides(root).forEach(function (slide) {
      if (slide.preview) {
        preloadUrl(slide.preview);
      }
      preloadUrl(slide.src);
    });
  }

  function updateNav() {
    if (!modal) {
      return;
    }
    var single = slides.length <= 1;
    modal.classList.toggle('npl--single', single);
    var prev = modal.querySelector('[data-npl-prev]');
    var next = modal.querySelector('[data-npl-next]');
    if (prev) {
      prev.disabled = single;
    }
    if (next) {
      next.disabled = single;
    }
  }

  function prefetchAdjacent() {
    if (slides.length <= 1) {
      return;
    }
    var nextI = (index + 1) % slides.length;
    var prevI = (index - 1 + slides.length) % slides.length;
    preloadUrl(slides[nextI].src);
    preloadUrl(slides[prevI].src);
  }

  function displayCurrent() {
    if (!imgEl || !slides.length) {
      return;
    }

    resetZoom();

    var slide = slides[index];
    var token = ++loadToken;
    var instant = slide.preview || slide.src;
    var needsUpgrade = instant && slide.src && instant !== slide.src;

    imgEl.alt = slide.alt;
    imgEl.classList.remove('npl__img--upgrading');
    imgEl.src = instant;

    if (!needsUpgrade) {
      modal.classList.remove('npl--loading');
      prefetchAdjacent();
      return;
    }

    modal.classList.add('npl--loading');
    imgEl.classList.add('npl__img--upgrading');

    preloadUrl(slide.src).then(function () {
      if (token !== loadToken || modal.hidden) {
        return;
      }
      imgEl.src = slide.src;
      imgEl.classList.remove('npl__img--upgrading');
      modal.classList.remove('npl--loading');
      prefetchAdjacent();
    });
  }

  function openAt(i) {
    if (!ensureModal() || !slides.length) {
      return;
    }
    index = Math.max(0, Math.min(i, slides.length - 1));
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('npl-open');
    updateNav();
    displayCurrent();
    var closeBtn = modal.querySelector('[data-npl-close].npl__btn--close');
    if (closeBtn) {
      closeBtn.focus();
    }
  }

  function close() {
    if (!modal) {
      return;
    }
    resetZoom();
    loadToken += 1;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('npl--loading');
    document.body.classList.remove('npl-open');
    if (imgEl) {
      imgEl.removeAttribute('src');
      imgEl.classList.remove('npl__img--upgrading');
    }
  }

  function go(delta) {
    if (slides.length <= 1) {
      return;
    }
    index = (index + delta + slides.length) % slides.length;
    displayCurrent();
  }

  function resolveIndex(el) {
    if (!el) {
      return 0;
    }
    var tile = el.closest('[data-nucery-zoom-index]');
    var raw = tile ? tile.getAttribute('data-nucery-zoom-index') : el.getAttribute('data-nucery-zoom-index');
    var n = parseInt(raw, 10);
    if (!isNaN(n) && n >= 0 && n < slides.length) {
      return n;
    }
    return 0;
  }

  function onGalleryClick(root, evt) {
    var tile = evt.target.closest('.nucery-pdp-gallery__tile');
    if (!tile || !root.contains(tile)) {
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();

    slides = collectSlides(root);
    if (!slides.length) {
      return;
    }
    openAt(resolveIndex(tile));
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-nucery-gallery-ready') === '1') {
      return;
    }
    root.setAttribute('data-nucery-gallery-ready', '1');

    root.addEventListener('click', function (evt) {
      onGalleryClick(root, evt);
    });

    warmCache(root);

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        warmCache(root);
      });
    } else {
      setTimeout(function () {
        warmCache(root);
      }, 400);
    }
  }

  function boot() {
    ensureModal();
    $all('[data-nucery-gallery]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
